import { Button, Form, Image, Modal, Select, Upload, notification } from "antd";
import { FC, useEffect } from "react";
import { useGetMyOrderList, useUpdateOrderPayment } from "services/order";
import { IPaymentNotiModalField } from "types/order";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { useUploadImage } from "services/image";
import { VITE_API_ENDPOINT } from "src/environments";
import { E_ORDER_STATUS } from "constants/common";

interface IPaymentNotificationModal {
  orderNumber?: number;
  isOpen: boolean;
  onClose: () => void;
}
const PaymentNotificationModal: FC<IPaymentNotificationModal> = ({
  orderNumber,
  isOpen,
  onClose,
}) => {
  const { orderList } = useGetMyOrderList(E_ORDER_STATUS.CONFIRMED);
  const { uploadImageAsync, isPending } = useUploadImage();
  const { updateOrderPaymentAsync, isPendingUpdateOrderPayment } =
    useUpdateOrderPayment();
  const [form] = Form.useForm();
  const slipUrl = Form.useWatch("slipUrl", form);

  const updatePaymentOrder = async () => {
    await updateOrderPaymentAsync({
      orderNumber: form.getFieldValue("orderNumber"),
      slipUrl,
    });
    onClose();
    notification.success({
      message: "แจ้งชำระเงินสำเร็จ",
      description: "รอเจ้าหน้าที่ตรวจสอบ",
      placement: "topRight",
    });
  };

  useEffect(() => {
    if (orderNumber) {
      form.setFieldValue("orderNumber", orderNumber);
    }
  }, []);

  const normFile = (e: any) => {
    if (e.fileList.length !== 0) {
      return e?.fileList;
    }
    return undefined;
  };

  const customRequest = (options: UploadRequestOption) => {
    const { file, onSuccess, onError } = options;
    if (file instanceof File) {
      uploadImageAsync(file, {
        onSuccess: (data) => {
          onSuccess?.(data.data); // Notify AntD Upload component of success
          form.setFieldValue(
            "slipUrl",
            `${VITE_API_ENDPOINT}/image-upload/${encodeURIComponent(
              data.data.imageUrl
            )}`
          );
        },
        onError: (error) => {
          onError?.(error); // Notify AntD Upload component of error
        },
      });
    }
  };

  return (
    <Modal
      footer={false}
      onCancel={onClose}
      onClose={onClose}
      open={isOpen}
      centered
      width={800}
      styles={{
        content: {
          height: 600,
          background: "#F9F9F9",
        },
        body: {
          height: "100%",
        },
      }}
      modalRender={(dom) => (
        <Form
          form={form}
          initialValues={{ modifier: "private" }}
          onFinish={updatePaymentOrder}
          onFinishFailed={() => console.log("onFinishFailed")}
        >
          {dom}
        </Form>
      )}
    >
      <div className="px-2 md:px-24 py-8 h-full">
        <div className="font-semibold text-center text-xl mb-8">
          แจ้งชำระเงิน
        </div>
        <div className="text-center h-full relative">
          <Form.Item<IPaymentNotiModalField>
            label="เลขที่ Order"
            name="orderNumber"
          >
            <Select
              showSearch
              options={orderList?.items.map((item) => ({
                value: item.id,
                label: item.id,
              }))}
              className="text-left"
            />
          </Form.Item>
          <Form.Item label="อัพโหลดสลิป" layout="vertical">
            <Form.Item<IPaymentNotiModalField>
              name="slipUrl"
              getValueFromEvent={normFile}
              rules={[
                {
                  required: true,
                  message: "กรุณา upload สลิปการโอนเงินของท่าน",
                },
              ]}
            >
              <Upload.Dragger
                name="files"
                customRequest={customRequest}
                accept="image/*"
              >
                {slipUrl && !isPending ? (
                  <Image src={slipUrl} height={200} />
                ) : (
                  <div
                    style={{
                      height: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p className="ant-upload-drag-icon"></p>
                    <p className="ant-upload-text">
                      คลิ๊กที่นี่ เพื่ออัพโหลดไฟล์
                    </p>
                  </div>
                )}
              </Upload.Dragger>
            </Form.Item>
          </Form.Item>
          <Button
            type="primary"
            size="large"
            className="w-80 absolute bottom-10 left-1/2 -translate-x-1/2"
            htmlType="submit"
            loading={isPendingUpdateOrderPayment}
          >
            แจ้งชำระเงิน
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default PaymentNotificationModal;
